<template>
  <div class="orderinfo-list">
    <div class="main-title">开具发票</div>
    <div class="main-part">
      <TableView
        :table-data="paginatedData"
        :columns="column"
        :loading="tabLoading"
        :actionColumn="true"
        :showTooltip="true"
        loading-txt="订单信息获取中···"
      >
        <template #empty>
          <div class="not_data">
            <div class="icon icon-cart-lg"></div>
            <div class="text">亲，暂无任何订单信息</div>
          </div>
        </template>
        <template #custom_buyTime>
          <div :class="['buy-date', { toUp: dateState == 'down' }]" @click="sortByDate(dateState)">
            <span>购买日期</span>
            <svg-icon name="Arrow-Down"></svg-icon>
          </div>
        </template>
        <!-- 操作列 -->
        <template #actions="{ scope }">
          <div
            v-if="scope.row.invoice_id && scope.row.paytype != '124'"
            class="had-invoice"
            @click="checkDetail(scope.row.invoice_id)"
          >
            查看发票>
          </div>
          <div
            v-if="!scope.row.invoice_id && scope.row.paytype != '124'"
            v-loading="prepareInvoice"
            element-loading-text="请稍后..."
            element-loading-background="#fff"
            class="not-invoice"
            @click="toOpenInvoice(scope.row.charge_id, scope.row.custom_type)"
          >
            开具发票
          </div>
        </template>
      </TableView>
      <Pagination
        :page-data="paginatedDataCopy"
        :page-size="pageSize"
        @page_changed="getCurrentPage"
      ></Pagination>
    </div>

    <el-dialog
      v-model="lianXiangTip"
      :close-on-click-modal="false"
      title=""
      class="lianXiang-tip"
      width="356"
      align-center
      center
    >
      <svg-icon name="Icon-Warning" size="32px"></svg-icon>
      <p>此订单为联想支付订单，开发票请加联想商店客服<br />QQ：2881414005</p>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="lianXiangTip = false" type="primary">知道了</el-button>
        </div>
      </template>
    </el-dialog>

    <InvoiceDialog
      v-if="invoiceDialog.show"
      v-model:showDialog="invoiceDialog.show"
      :curInvoiceType="invoiceDialog.curInvoiceType"
      v-model:seeDetail="invoiceDialog.seeDetail"
      :invoiceId="invoiceDialog.invoiceId"
      :whichInvoice="invoiceDialog.whichInvoice"
      :type="invoiceDialog.type"
      :orderType="invoiceDialog.orderType"
      @was_pass="invoiceWasPass"
    ></InvoiceDialog>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

// 组件路由守卫
export default defineComponent({
  beforeRouteEnter(to, from, next, e) {
    next(e => {
      if (from.name == 'cad_autologin') {
        let id = e.route.query.cid
        let type = e.route.query.type
        e.toOpenInvoice(id, type)
      }
    })
  }
})
</script>

<script setup>
import TableView from '@/components/publicModule/TableView.vue'
import Pagination from '@/components/publicModule/Pagination.vue'
import InvoiceDialog from '@/components/cad/InvoiceDialog.vue'
import { useMapState } from '@/assets/js/use_storemap'
import {
  apiGetOrderskplist,
  apiGetGalleryOrderInfo,
  apiJudgeOrderType
} from '@/api/modules/cad_api'
import tool from '@/assets/js/tool'
import msg from '@/utils/message'
import { useRouter, useRoute } from 'vue-router'
import { onBeforeMount, onMounted, ref } from 'vue'

/* --- 全局变量 --- */
// vuex
const { Token } = useMapState({
  Token: state => state.user.token
})

// router
const router = useRouter()
const route = useRoute()

const paginatedData = ref([])
const paginatedDataCopy = ref([])
const column = ref([
  { prop: 'ordersn', label: '订单号', width: '220' },
  { prop: 'name', label: '开通项目', width: '184', tooltip: true },
  { prop: 'custom_buyTime', label: '购买日期', width: '208', slotHead: 'custom_buyTime' },
  { prop: 'money', label: '金额（元）', width: '120' }
])
let originalWidths = null
const pageSize = 9
let currentPage = ref(1)
let vipData = ref([])
let galleryData = ref([])
let dateState = ref('')
let tabLoading = ref(false)
let lianXiangTip = ref(false)
let prepareInvoice = ref(false) // 点击 “开具发票” 时添加遮罩
const invoiceDialog = ref({
  show: false,
  curInvoiceType: 0,
  seeDetail: false, // 查看详细?
  invoiceId: '',
  whichInvoice: '',
  type: '',
  orderType: ''
})

/* --- 函数方法 --- */
onBeforeMount(async () => {
  if (route.path == '/personal/userinvoice1' || route.path == '/personal/userinvoice2') {
    let invoice = '1'
    let id = route.query.cid
    let type = route.query.type
    if (route.path == '/personal/userinvoice1') {
      invoice = '1'
    } else if (route.path == '/personal/userinvoice2') {
      invoice = '2'
    }

    toOpenInvoice(id, type, invoice)
  }

  setPaginated()
})

onMounted(() => {
  getClientWidth()
  window.addEventListener('resize', () => {
    getClientWidth()
  })
})

const getVipOrders = async () => {
  try {
    const res = await apiGetOrderskplist({
      user_token: Token.value
    })
    if (res.code == 1) {
      vipData.value = res.param1.map(obj => ({
        ...obj,
        custom_type: 'vip'
      }))
    }
  } catch (error) {
    console.log('Error:', error)
  }
}

const getGalleryOrders = async () => {
  try {
    const res = await apiGetGalleryOrderInfo({
      user_token: Token.value
    })
    if (res.code == 1) {
      galleryData.value = res.param1.map(obj => ({
        ...obj,
        custom_type: 'gallery'
      }))
    }
  } catch (error) {
    console.log('Error:', error)
  }
}

const setPaginated = async () => {
  tabLoading.value = true

  try {
    await getVipOrders()
    await getGalleryOrders()
  } catch (error) {
    msg.e({ msg: '订单信息获取失败，请稍后再试', duration: 4000 })
    console.log('Error:', error)
  } finally {
    setTimeout(() => {
      tabLoading.value = false
    }, 500)
  }

  paginatedDataCopy.value = [...vipData.value, ...galleryData.value].map(obj => ({
    ...obj,
    custom_buyTime: obj.insert_time || obj.pay_time
  }))
  sortByDate('down')
  getCurrentPage(1)
}

const sortByDate = (type = 'down') => {
  paginatedDataCopy.value.sort((a, b) => {
    if (type == 'down') {
      dateState.value = 'up'
      return new Date(b.custom_buyTime) - new Date(a.custom_buyTime)
    } else {
      dateState.value = 'down'
      return new Date(a.custom_buyTime) - new Date(b.custom_buyTime)
    }
  })

  getCurrentPage(currentPage.value)
}

const getCurrentPage = page => {
  currentPage.value = page
  const start = (page - 1) * pageSize
  const end = start + pageSize
  paginatedData.value = paginatedDataCopy.value.slice(start, end)
}

/*
  invoice: 1（跳普票）、2（跳专票）
*/
const toOpenInvoice = async (id, type, invoice = '1') => {
  try {
    if (!tool.isAllDigits(id) && (type != 'gallery' || type != 'vip')) return

    invoiceDialog.value.type = '1'
    prepareInvoice.value = true
    const res = await apiJudgeOrderType({ cid: id, type })
    prepareInvoice.value = false
    if (res.code == 1) {
      invoiceDialog.value.orderType = res.param1.type
      if (res.param1.type != '2') {
        if (invoice == '1') {
          router.push({
            path: '/personal/userinvoice1',
            query: { cid: '' + id + '', type }
          })
        } else {
          router.push({
            path: '/personal/userinvoice2',
            query: { cid: '' + id + '', type }
          })
        }

        invoiceDialog.value.type = '1'
        invoiceDialog.value.whichInvoice = type
        if (invoice == '2') {
          invoiceDialog.value.curInvoiceType = 1
        } else {
          invoiceDialog.value.curInvoiceType = 0
        }

        invoiceDialog.value.show = true
      } else {
        lianXiangTip.value = true
      }
    }
  } catch (error) {
    msg.e({ msg: '获取发票类型失败，请稍后再试', duration: 4000 })
    console.log('Error:', error)
  }
}

const checkDetail = id => {
  invoiceDialog.value.type = '2'
  invoiceDialog.value.show = true
  invoiceDialog.value.seeDetail = true
  invoiceDialog.value.invoiceId = id
}

const invoiceWasPass = flag => {
  if (flag) {
    setPaginated()
  }
}

function getClientWidth() {
  const clientWidth = window.innerWidth || document.body.offsetWidth

  // 首次调用时保存原始宽度
  if (!originalWidths) {
    originalWidths = column.value.map(item => item.width)
  }

  // 根据窗口宽度选择缩放比例
  let scale = 1
  if (clientWidth >= 1921 && clientWidth <= 2560) scale = 1.2
  else if (clientWidth > 2560) scale = 2

  // 始终基于原始宽度计算
  column.value.forEach((item, index) => {
    if (originalWidths[index] !== undefined) {
      item.width = originalWidths[index] * scale
    }
  })
}

defineExpose({ router, route, toOpenInvoice })
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_make.scss';
@import '@/assets/scss/common.scss';
.orderinfo-list {
  height: 100%;
  .main-part {
    @include responsive-style(
      (
        margin-top: 40px
      )
    );
    @include make-attributes-custom(lg, ()) {
      height: calc(100% - 89px);
    }
    @include make-attributes-custom(xl, ()) {
      height: calc(100% - 101px);
    }
    @include make-attributes-custom(mx, ()) {
      height: calc(100% - 178px);
    }

    :deep(.table-view) {
      height: 89%;

      .not_data {
        padding-bottom: 13vh;
        .icon-cart-lg {
          width: 80px;
          height: 66px;
          margin: 13vh auto 0;
          background-image: url('@/assets/img/cadOld/icons-cloud.png');
          background-position: -10px -576px;
        }

        .text {
          text-align: center;
          color: #333;
          @include responsive-style(
            (
              margin-top: 20px,
              line-height: 14px
            )
          );
        }
      }

      .buy-date {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.toUp {
          .svg-icon {
            transform: rotate(180deg);
          }
        }

        .svg-icon {
          @include responsive-style(
            (
              width: 14px,
              height: 14px,
              margin-left: 4px
            )
          );
        }
      }

      .had-invoice,
      .not-invoice {
        color: $--themecolor;
        cursor: pointer;
        user-select: none;
      }

      .not-invoice {
        margin: 0 auto;
        text-align: center;
        @include responsive-style(
          (
            width: 80px,
            padding: 4px,
            border-radius: 2px,
            border: 1px solid $--themecolor
          )
        );

        .el-loading-mask {
          .el-loading-spinner {
            position: unset;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
          }
          .circular {
            display: none;
          }
        }
      }
    }

    :deep(.pagination) {
      @include responsive-style(
        (
          margin-top: 23px
        )
      );
    }
  }

  :deep(.lianXiang-tip) {
    border-radius: 8px;
    background: #fff;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__headerbtn {
      top: 4px;
      right: 2px;
      width: 32px;
      height: 32px;

      .el-dialog__close {
        color: #979797;
      }
    }

    .el-dialog__body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 24px 0;

      .svg-icon {
        margin-bottom: 4px;
      }

      p {
        text-align: center;
        color: #222;
        font-size: 14px;
      }
    }

    .el-dialog__footer {
      padding: 24px 24px 16px;

      .el-button--primary {
        padding: 8px 32px;
        border-radius: 8px;
        border-color: #147fff;
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        background: #147fff;
      }
    }
  }
}
</style>
